import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService } from '../../services/login.service';

@Component({
    selector: 'navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {

    constructor(private router: Router, private loginService: LoginService) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    logout() {
        this.loginService.logout();
        this.router.navigate(['/login']);
    }
}
